import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal } from "../Reveal";
import { buildWhatsAppLink } from "../../lib/site";

const faqs = [
  { q: "Ce acte îmi trebuie pentru înscriere?", a: "Ai nevoie de cartea de identitate, fișa medicală de la un cabinet autorizat și avizul psihologic. Te ajutăm noi cu toți pașii necesari." },
  { q: "Cât durează școala de șoferi pentru categoria B?", a: "În medie, între 4 și 8 săptămâni, în funcție de ritmul tău și de disponibilitatea programului. Ne adaptăm nevoilor tale." },
  { q: "Câte ore de conducere sunt incluse?", a: "Pachetul standard include numărul minim legal de ore de practică. Poți adăuga oricând ore suplimentare, la un tarif preferențial." },
  { q: "Cine beneficiază de reducerea de 20%?", a: "Elevii, studenții, pensionarii și șomerii beneficiază de 20% reducere. Adu un document doveditor la înscriere." },
  { q: "Pot să îmi aleg singur programul orelor?", a: "Da! Avem program flexibil, inclusiv dimineața, seara și în weekend. Stabilim orele împreună, în funcție de disponibilitatea ta." },
  { q: "Ce se întâmplă dacă nu promovez examenul din prima?", a: "Nicio grijă — te repregătim și te susținem cu ședințe suplimentare de pregătire, până treci examenul." },
];

export const FAQ = () => (
  <section id="intrebari" data-testid="faq-section" className="py-24 lg:py-36 bg-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-8">
      {/* Biroul de informații — sticky, calea de contact rămâne vizibilă */}
      <div className="lg:col-span-4 lg:col-start-2">
        <Reveal className="lg:sticky lg:top-32">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1565C0]">Întrebări frecvente</p>
          <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900">
            Răspunsuri la ce te interesează
          </h2>
          <div className="mt-8">
            <p className="text-slate-600">Ai altă întrebare?</p>
            <a
              href={buildWhatsAppLink("Bună ziua! Am o întrebare despre școala auto Auto Valy Drive.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="faq-whatsapp-btn"
              className="mt-2 inline-flex items-center gap-2 text-[#1565C0] font-semibold hover:underline"
            >
              Scrie-ne pe WhatsApp →
            </a>
          </div>
        </Reveal>
      </div>

      {/* Acordeonul — rânduri tipărite pe foaie */}
      <div className="lg:col-span-6 lg:col-start-7">
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="border-t border-slate-200">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-0 border-b border-slate-200 px-0"
              >
                <AccordionTrigger className="text-left font-display font-semibold text-lg text-slate-900 hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed text-[15px] pb-6 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);

export default FAQ;
